import { withStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

export const CustomTooltip = withStyles(() => ({
  tooltip: {
    fontSize: 12,
    textAlign: 'center'
  }
}))(Tooltip);
